import './css/styles.scss';

function losningarInit(): void {}

losningarInit();
